export default __webpack_public_path__ + "static/media/user.bfa66a47.svg";